import React, { useEffect, useState } from "react";
import FacetFilter from "models/facet-filter";
import { useSearchParams } from "react-router-dom";
import NTFilterList from "./nt-filter-list";
import BaseFilterList from "./base-filter-list/BaseFilterList";

const FilterList = ({
  facetType,
  facetFilters,
  OnUpdated,
  index,
}: {
  facetType: string;
  facetFilters?: FacetFilter[];
  OnUpdated: (filterType: string, filter: string) => void;
  index: number;
}) => {
  const [searchParams] = useSearchParams();
  const [open, setOpen] = useState(
    !["FAF-nt"].includes(process.env.REACT_APP_STYLING_THEME ?? ""),
  );

  useEffect(() => {
    if (searchParams.get(facetType)) {
      setOpen(true);
    }
  }, [searchParams]);

  return ["FAF-nt"].includes(process.env.REACT_APP_STYLING_THEME ?? "") ? (
    <NTFilterList
      OnUpdated={(newFilterType, newFilter) =>
        OnUpdated(newFilterType, newFilter)
      }
      facetType={facetType}
      index={index}
      facetFilters={facetFilters}
      open={open}
      HandleOpen={setOpen}
    />
  ) : (
    <BaseFilterList
      OnUpdated={(newFilterType, newFilter) =>
        OnUpdated(newFilterType, newFilter)
      }
      facetType={facetType}
      index={index}
      facetFilters={facetFilters}
      open={open}
      HandleOpen={setOpen}
    />
  );
};

export default FilterList;
